<div class="py-12">
    <div *ngIf="loading" class="flex flex-col justify-center items-center grow">
        <mat-spinner></mat-spinner>
    </div>
    
    <!-- Enrollment Period Warning -->
    <div *ngIf="isEnrollmentPeriodInvalid()" class="flex flex-col justify-center items-center grow w-full">
        <div class="bg-amber-50 border-l-4 border-amber-500 text-amber-900 p-6 mb-4 max-w-2xl mx-4" role="alert">
            <div class="flex items-start">
                <svg class="w-6 h-6 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
                <div>
                    <strong class="font-bold block mb-1">{{ getEnrollmentPeriodWarningTitle() }}</strong>
                    <span class="block">{{ getEnrollmentPeriodWarningMessage() }}</span>
                </div>
            </div>
        </div>
    </div>
    
    <div *ngIf="error && step !== 'closed'" class="flex flex-col justify-center items-center grow w-full">
        <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mb-2" role="alert">
            <strong class="font-bold">Whoops! </strong>
            <span class="block sm:inline">{{error}}</span>
        </div>
    </div>
    
    <div *ngIf="step === 'closed'" class="flex flex-col justify-center items-center grow w-full">
        <app-enrollment-closed></app-enrollment-closed>
    </div>

    <div *ngIf="step === 'verify' && !loading && !isEnrollmentPeriodInvalid()" class="flex flex-col justify-center items-center grow w-full">
        <app-verify-identity
            [sessionToken]="sessionToken"
            [maskedEmail]="maskedEmail"
            [memberData]="memberData"
            [infoMessage]="verifyInfoMessage"
            [otpExpiresAt]="otpExpiresAt"
            [isEmailVerified]="isEmailVerified"
            (verify)="emailVerified($event)"
            (error)="verifyError($event)"
            (otpExpiresAtUpdated)="otpExpiresAt = $event">
        </app-verify-identity>
    </div>
    
    <div *ngIf="clientInfo && !isEnrollmentPeriodInvalid()" [hidden]="loading || step === 'verify'" class="flex flex-col justify-center items-center grow w-full">
        <app-member-form 
            [hidden]="step !== 'data'" 
            [companyCode]="clientInfo.cCode"  
            [products]="clientInfo.products" 
            [selectedProducts]="selectedProducts"
            [defaultPaymentFrequency]="clientInfo.defaultPaymentFrequency"
            [discount]="discountApplied"
            [existingData]="memberData"
            [billingType]="clientInfo.billingType"
            [requireEmployeeId]="clientInfo.requireEmployeeId"
            [enrollmentType]="enrollmentType"
            (continue)="memberDataCompleted($event)">
        </app-member-form>
        
        <app-checkout *ngIf="step === 'payment'"
            [memberData]="memberData"
            [validationToken]="validationToken"
            [sessionToken]="sessionToken"
            [products]="selectedPlans"
            [discountApplied]="discountApplied"
            [billingType]="clientInfo.billingType"
            (complete)="completeEnrollment($event)"
            (back)="backToVerification()">
        </app-checkout>
        
        <app-confirmation *ngIf="step === 'confirmation'" 
            [member]="memberData" 
            [discountApplied]="discountApplied"
            [plans]="selectedPlans"
            [effectiveDate]="confirmationEffectiveDate">
        </app-confirmation>
    </div>  
</div>